import http from '@root/utils/axios/admin';

let state = {
    GameCategoriesList: [],
    GameCategory: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchGameCategoriesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/game-categories', { params: filter }).then((response) => {
                commit('setGameCategoriesList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteGameCategory({ commit }, id) {
        return http.delete('user/game-categories/' + id);
    },

    fetchGameCategory({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('user/game-categories/' + id).then((response) => {
                commit('setGameCategory', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateGameCategory({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/game-categories', data).then((response) => {
                commit('setGameCategory', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGameCategoryError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateGameCategory({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/game-categories/' + data.id, data).then((response) => {
                commit('setGameCategory', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGameCategoryError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setGameCategoriesList(state, data) {
        state.GameCategoriesList = data;
    },
    setGameCategory(state, data) {
        state.GameCategory.data = data;
    },
    setGameCategoryError(state, error) {

        state.GameCategory.error = error.errors;
    },
    cleanGameCategoryError(state, error) {
        state.GameCategory.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}